
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';
import { getSuluPage } from 'razlet-sulu-sdk/lib/utils/helpers';
import { getTabloData } from '~/utils/tablo';

export default {
  name: 'tablo-page',
  layout: 'half-blue',
  mixins: [sulu],
  async asyncData ({ store, route, error, redirect }) {
    const result = await getSuluPage({ store, route, error, redirect });
    const tablo = await getTabloData({ store, route });
    return { tablo, result };
  },
  data () {
    return {
      tablo: {},
    };
  },
};
